import React from "react"
import { Col } from "antd"
import style from "./Footer.module.scss"

export default () => {
  const colProps = {
    className: style.topColumn,
    span: 24,
  }

  return (
    <Col {...colProps}>
      <img
        alt="The logo for Lantern Lodge - A StaySRG Destination"
        src="/logos/LL-StaySRG.svg"
        style={{ margin: `1rem auto`, maxWidth: `90vw`, width: 300 }}
      />
    </Col>
  )
}
